import packageConfig from '../package.json'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { Platform } from '@monogrid/js-utils'

import router from './plugins/router.js'
import './plugins/analytics.js'
import './plugins/locale.js'
import VueMeta from 'vue-meta'
import VueEvents from 'vue-event-handler'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Preloader from './preloader'
import SEOVImg from './atoms/SEOVImg'
import onlineApolloProvider from './services/CMS'
import soundManager from './services/SoundManager'
// import CMSOffline from './services/CMSOffline'
// import cmsOfflineCatalog from './services/CMSOfflineCatalog.json'
// import cmsOfflineSchema from './services/CMSOfflineSchema.graphql'

import VuePlyr from 'vue-plyr'

// usage: https://vuetifyjs.com/
import vuetify from './plugins/vuetify'
// usage: https://github.com/declandewet/vue-meta
Vue.use(VueMeta)
// usage: https://github.com/sandeepk01/vue-event-handler
Vue.use(VueEvents)
// usage: https://github.com/imcvampire/vue-axios
Vue.use(VueAxios, axios)
// For use custom video player
Vue.use(VuePlyr)
// add seo friendly version of v-img
Vue.component('seo-v-img', SEOVImg)

//
//
// Initialization of the preloader app (placed on the HTML)
//
//
const preloaderInstance = new Vue(Preloader)

// management of languages
router.beforeEach((to, from, next) => {
  // set current language on change route
  // preloaderInstance.visible = true
  if (packageConfig.multilanguage) {
    if (to.params.language) {
      Vue.config.language = to.params.language || 'en'
    }
  } else {
    Vue.config.language = 'en'
  }
  next()
})

const routerGuards = (app) => {
  if (app.siteSettings) {
    if (app.siteSettings.teaserMode && app.$route.name !== 'Teaser') {
      app.$router.replace({ name: 'Teaser' })
    }
    if (app.siteSettings.invitationMode && app.$route.name !== 'Invitation' && !app.userPassedThroughInvitation) {
      app.$router.replace({ name: 'Teaser' })
    }
  }
}

// Platform.prerenderer = true
//
//
// Initialization of the app (placed on the HTML)
//
//
const app = new Vue({
  el: '#app',
  router,
  vuetify,
  /**
   * this is an example of using the online server in production
   * and using offline mock data in other stages (develop, master, etc)
   */
  // apolloProvider: process.env.SERVICE_STAGE !== 'some-offline-stage' ? onlineApolloProvider : new CMSOffline(cmsOfflineCatalog, cmsOfflineSchema).getProvider(),
  apolloProvider: onlineApolloProvider,
  /**
   * use this if you want the offline version of the CMS data
   */
  // apolloProvider: onlineApolloProvider,
  data () {
    return {
      soundManager,
      preloader: preloaderInstance,
      userPassedThroughInvitation: localStorage.getItem('userPassedThroughInvitation') || false,
      siteSettings: null,
      process: {
        env: process.env
      }
    }
  },

  watch: {
    siteSettings (value) {
      routerGuards(this)
    }
  },

  computed: {
    platform () {
      return Platform
    },
    multilanguage () {
      return packageConfig.multilanguage
    }
  },
  // this block allows passing props to the main App
  // these props are set by html-webpack-plugin in the html
  // and the values are taken from git-revision-webpack-plugin
  render (createElement) {
    return createElement(App, {
      props: {
        preloader: preloaderInstance
      }
    })
  }
})

router.afterEach((to, from) => {
  // preloaderInstance.visible = false
  let routeMuted = false
  if (to.meta && typeof to.meta === 'function') {
    const meta = to.meta(to)
    routeMuted = meta.soundManagerMuted
  }

  if (routeMuted) soundManager.mute('route')
  else soundManager.unmute('route')

  routerGuards(app)
})
